// @mui material components
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import Slide from "@mui/material/Slide";

// @mui icons
import CloseIcon from "@mui/icons-material/Close";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

import PropTypes from "prop-types";

function SimpleModal({
  open,
  title,
  children,
  cancelLabel,
  confirmLabel,
  showCancel,
  showConfirm,
  onClose,
  onConfirm,
}) {
  return (
    <Modal open={open} onClose={onClose} sx={{ display: "grid", placeItems: "center" }}>
      <Slide direction="down" in={open} timeout={500}>
        <MKBox
          position="relative"
          width="500px"
          maxWidth="90vw"
          display="flex"
          flexDirection="column"
          borderRadius="xl"
          bgColor="white"
          shadow="xl"
        >
          <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
            <MKTypography variant="h5">{title}</MKTypography>
            <CloseIcon fontSize="medium" sx={{ cursor: "pointer" }} onClick={onClose} />
          </MKBox>
          <Divider sx={{ my: 0 }} />
          <MKBox p={2}>
            {typeof children === "string" ? (
              <MKTypography variant="body2" color="secondary" fontWeight="regular">
                {children}
              </MKTypography>
            ) : (
              children
            )}
          </MKBox>
          {(showCancel || showConfirm) && (
            <>
              <Divider sx={{ my: 0 }} />
              <MKBox display="flex" justifyContent="flex-end" gap={1} p={1.5}>
                {showCancel && (
                  <MKButton variant="gradient" color="dark" onClick={onClose}>
                    {cancelLabel}
                  </MKButton>
                )}
                {showConfirm && (
                  <MKButton variant="gradient" color="info" onClick={onConfirm}>
                    {confirmLabel}
                  </MKButton>
                )}
              </MKBox>
            </>
          )}
        </MKBox>
      </Slide>
    </Modal>
  );
}

SimpleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node,
  cancelLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  showCancel: PropTypes.bool,
  showConfirm: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

SimpleModal.defaultProps = {
  children: null,
  cancelLabel: "取消",
  confirmLabel: "确认",
  showCancel: true,
  showConfirm: true,
  onConfirm: () => {},
};

export default SimpleModal;
